module.exports = __webpack_public_path__ + "img/wfzc-nav.675048e.svg";